import React, {Component} from "react";
import {Story} from "models/story/Story";

import "./BannerStory.scss";
import StoryTitleImage from "components/public/pages/webgl_app/StoryTitleImage";
import RascalLogo from "layouts/headers/RascalLogo";
import {Link} from "react-router-dom";
import StoryDetailsButton from "components/public/pages/webgl_app/StoryDetailsButton";
import PlayIcon from "components/shared/icons/PlayIcon";

interface IBannerStoryProps {
    story: Story;
}

class BannerStory extends Component<IBannerStoryProps> {

    constructor(props: IBannerStoryProps) {
        super(props);
        this.playClicked = this.playClicked.bind(this);
    }

    private playClicked() {
        const {story} = this.props;
        window.location.href = `/story/${story.id}`;
    }

    render() {
        const {story} = this.props;
        const {default_localisation} = story;
        let color: string = default_localisation?.featured_text_color || '#000';

        return (
            <div className="banner-story">
                <img className='rk-home--banner-img landscape' width='100%' src={default_localisation.featured_landscape_image_url} />
                <img className='rk-home--banner-img portrait' width='100%' src={default_localisation.portrait_image_url} />
                <div className="banner-story-content">
                    <StoryTitleImage className='landscape-only' story={story} />
                    <div className="banner-story-logo landscape-only">
                        <RascalLogo color={color} />
                    </div>
                    <div className='banner-story-play'>
                        <StoryDetailsButton label='Play' icon={<PlayIcon />} color='white' cursor='pointer' onClick={e => this.playClicked()} />
                    </div>
                </div>
            </div>
        );
    }
}
export default BannerStory;
